import { DataModel } from "common/models/utility-models/base-model";

export class MentoringDocumentModel extends DataModel {
    quarter_number: number = null;
    year_number: string = null;
    mentoringDoc: any = '';
}
